import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Stack,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { TruncatedText, StyledIconBox } from './DeviceInfo.style';
import { NextIcon, PrevIcon } from './Icons';
import DetailDialog from './Dialog';
import DefaultUptimeTheme from "../../theme/defaultTheme";
import { useTheme } from 'styled-components';
import parse from 'html-react-parser';

export interface IDeviceInfo {
  currentDevice: any,
  products: any,
  manageLandingPageTranslation: any,
  handleOrderDevice: () => {},
  isOrderAllowed: any,
  generalConfig: any,
  prevDevice: () => {},
  nextDevice: () => {},
  handleMarkOrderItemReceived: () => {},
  currentImageProp: any,
  locale: any,
};

const DeviceInfo = (props: IDeviceInfo) => {
  const { 
    currentDevice, 
    products, 
    isOrderAllowed, 
    generalConfig, 
    handleOrderDevice, 
    prevDevice, 
    nextDevice,
    handleMarkOrderItemReceived,
    currentImageProp,
    locale,
  } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme() as typeof DefaultUptimeTheme;

  const getImage = () => {
    const { pictures } = currentDevice;
    const picture = pictures && pictures.length > 0 ? pictures[0] : null;
    return picture ? (picture.large || picture.medium || picture.small) : '';
  };


  return (
    <>
      <Card sx={{ borderRadius: 1, maxHeight: '393px', height: '100%', boxShadow: `0px 0px 0px 1px ${theme.uptimeColors.grayScales.boxShadow}` }}>
        <CardHeader
          sx={{ padding: '10px 16px 0 16px' }}
          title={
            <Typography variant="h6" color="black">
              {locale?.cardDeviceDetail?.title?.myDeviceDetail}
            </Typography>
          }
          action={
            products?.length > 1 ? (<Box sx={{ padding: 1, display: 'flex' }}>
              <StyledIconBox onClick={prevDevice} sx={{ marginRight: '6px' }}>
                <PrevIcon />
              </StyledIconBox>
              <StyledIconBox onClick={nextDevice}>
                <NextIcon />
              </StyledIconBox>
            </Box>) : <></>
          }
        />
        {currentDevice ? (
          <CardContent
            sx={{ maxHeight: '353px', overflow: 'auto', boxShadow: 'none', padding: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          >
            <Box sx={{ paddingX: '70px', paddingBottom: 2 }}>
              <CardMedia
                sx={{ height: 150, backgroundSize: 'contain' }}
                image={getImage()}
                component="img"
                alt={currentDevice.name}
                title={currentDevice.name}
              />
            </Box>
            <Stack direction="column" flex={1}>
              <Typography gutterBottom variant="overline" color="text.secondary" textTransform="uppercase">
                {currentDevice.brand.name}
              </Typography>
              <CardHeader
                sx={{ padding: 0 }}
                title={
                  <TruncatedText maxlines={1} variant="h5" title={currentDevice.name} width="fit-content">
                    {currentDevice.name}
                  </TruncatedText>
                }
                subheader={
                  <TruncatedText
                    maxlines={1}
                    variant="body2"
                    color="text.secondary"
                    letterSpacing={0.17}
                    mt={1}
                    mb={2}
                  >
                    {currentDevice.descriptionText}
                  </TruncatedText>
                }
              />
              <Button onClick={() => setOpenDialog(true)} size="medium" color='primary' variant='contained'>{locale?.cardDeviceDetail?.buttonLabel?.viewDetail}</Button>
            </Stack>
          </CardContent>
        ) :
          isOrderAllowed ?
            <CardContent>
              <Typography variant="body2" color="text.secondary" >
                {parse(generalConfig?.cardDeviceDetail?.message?.allow_order_device?.not_order_yet || locale?.cardDeviceDetail?.message.allow_order_device.not_order_yet)}
              </Typography>
              <Stack direction="column" flex={1} mt={2}>
                <Button onClick={handleOrderDevice} size="medium" color='primary' variant='contained'>{generalConfig?.cardDeviceDetail?.buttonLabel?.orderDevice || locale?.cardDeviceDetail?.buttonLabel?.orderDevice}</Button>
              </Stack>
            </CardContent>
            :
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                {generalConfig?.cardDeviceDetail?.message?.not_allowed_order_device?.not_order_yet  || locale?.cardDeviceDetail?.message?.not_allowed_order_device.not_order_yet}
              </Typography>
            </CardContent>
        }
      </Card>
      {openDialog && <DetailDialog product={currentDevice} onClose={() => setOpenDialog(false)} currentImageProp={currentImageProp} onMarkAsReceived={handleMarkOrderItemReceived} locale={locale}/>}
    </>
  );
};

export default DeviceInfo;
